import { useQuery } from "@tanstack/react-query";
import { agentsApi } from "@/features/agents/api";
import { callsApi } from "@/features/calls/api";

export const useAgents = () =>
  useQuery({
    queryKey: ["agents", "list"],
    queryFn: () => agentsApi.list(),
    staleTime: 30_000,
  });

// No `ordering` param — DRF's OrderingFilter is on globally, so passing
// `ordering=-started_at` actually reorders results and ranks pending
// calls (started_at NULL) ahead of completed ones. Trust the model's
// Meta.ordering = ['-created_at'] default instead, matching legacy.
export const useRecentCalls = (limit = 5) =>
  useQuery({
    queryKey: ["calls", "list", { limit }],
    queryFn: () => callsApi.list({ limit }),
    staleTime: 15_000,
  });

export const useCallStats = () =>
  useQuery({
    queryKey: ["calls", "stats"],
    queryFn: () => callsApi.stats(),
    staleTime: 30_000,
  });
